namespace $.$$ {

	$mol_style_define( $shm_hitalama_map_widget_float_tabulator, {

		background: {
			color: $mol_theme.card,
		},

	} )

}
